import { Button } from "@/components/ui/button";
import { Image } from "@/components/ui/image";
import { Link } from "react-router-dom";

export const PageNotFound = () => {
  return (
    <div className="flex items-center h-full relative w-full">
      <div className="flex items-center h-full relative w-full justify-center flex-col">
        <Image
          src="/images/404.jpg"
          alt=""
          className="h-[400px] mt-[-100px] mix-blend-multiply"
        />
        <h1 className="pt-4 text-xl font-semibold text-slate-800 dark:text-navy-50">
          Oops. This Page Not Found.
        </h1>
        <div className="py-2 mb-5 text-slate-500 dark:text-navy-200">
          This page you are looking not available. Please back to home
        </div>
        <Link to="/">
          <Button>Back to Home</Button>
        </Link>
      </div>
    </div>
  );
};
